import { render, staticRenderFns } from "./MRC_ESS_PropertyList.vue?vue&type=template&id=8c70ce84&"
import script from "./MRC_ESS_PropertyList.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_PropertyList.vue?vue&type=script&lang=js&"
import style0 from "./MRC_ESS_PropertyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c70ce84')) {
      api.createRecord('8c70ce84', component.options)
    } else {
      api.reload('8c70ce84', component.options)
    }
    module.hot.accept("./MRC_ESS_PropertyList.vue?vue&type=template&id=8c70ce84&", function () {
      api.rerender('8c70ce84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_PropertyList.vue"
export default component.exports